import { ORGANIZATION_LOGO, ORGANIZATION_NAME } from "../constants";

export default {
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: "https://fithub.com.co",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `https://fithub.com.co/search?query={query}`,
    },
    "query-input": "required name=query",
  },
  countryOfOrigin: {
    "@type": "Country",
    name: "COL",
  },
  isFamilyFriendly: true,
  isAccessibleForFree: true,
  name: ORGANIZATION_NAME,
  description: "Evoluciona tus hábitos saludables",
  inLanguage: "es",
  publisher: {
    "@type": "Organization",
    name: ORGANIZATION_NAME,
    logo: {
      "@type": "ImageObject",
      url: ORGANIZATION_LOGO,
    },
  },
  sameAs: [
    "https://www.instagram.com/fithub_co",
    "https://www.facebook.com/FitHubco",
    "https://www.youtube.com/channel/UCCVbPuguSB8X7CU7jZdgsoQ",
    "https://www.linkedin.com/company/fithub-colombia",
  ],
};
